import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import DateField from "../system/dateField";
import {submitSchedule, updateSchedule} from "../../services/schedule/schedule";
import Validator from "../../helper/validator/Validator";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import {Toaster} from "../../helper/Toaster";
import {FromToTimeClock} from "../system/fromToTimeClock/timeClock";
import {checkAll} from "../../helper/validator/Check";

export function ScheduleForm({schedule, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(schedule?.id ?? null);
  const [title, setTitle] = useState(schedule?.title ?? "تایم آزاد");
  const [startDate, setStartDate] = useState(schedule?.start_date ?? "");
  const [endDate, setEndDate] = useState(schedule?.end_date ?? "");
  const [weekDayId, setWeekDayId] = useState(schedule?.week_day_id ?? null);
  const [startTime, setStartTime] = useState(schedule?.start_time ?? "");
  const [endTime, setEndTime] = useState(schedule?.end_time ?? "");
  const [status, setStatus] = useState(schedule?.status === 'enable');

  useEffect(() => {
    if (schedule) {
      setId(schedule.id ?? null);
      setTitle(schedule.title ?? "تایم آزاد");
      setStartDate(schedule.start_date ?? "");
      setEndDate(schedule.end_date ?? "");
      setWeekDayId(schedule.week_day_id ?? null);
      setStartTime(schedule.start_time ?? "");
      setEndTime(schedule.end_time ?? "");
      setStatus(schedule.status === 'enable');
    }
  }, [schedule]);

  const save = async () => {
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
      return
    }
    const data = {
      id: id,
      title: title,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      week_day_id: weekDayId,
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitSchedule(data);
    } else {
      result = await updateSchedule(data);
    }

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
      setGridSelectedRow(null)
      handleOpen()
    }
  };

  return (
    <ValidatorProvider>
      {schedule &&
        <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>ویرایش/جدید</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll max-h-[700px]">

            <div className="mb-4">
              <Input variant="standard"
                     value={"تایم آزاد"}
                     label={'عنوان'}
                     placeholder={'عنوان'}
                     onChange={(e) => {
                       e.target.value = "تایم آزاد";
                     }}
              />
            </div>

            <div className=" w-full mb-4">
              <DateField
                className="my-4 mx-4 w-full"
                date={startDate}
                setDate={setStartDate}
                label="از تاریخ"
              />
              <Validator state={startDate} rules={`required`}/>
            </div>

            <div className="w-full mb-4">
              <DateField
                className="my-4 mx-4 w-full"
                date={endDate}
                setDate={setEndDate}
                label="تا تاریخ"
              />
              <Validator state={endDate} rules={`required`}/>
            </div>

            <Select variant="static" className="rtl" dir="rtl"
                    label={Dict('one_week_day')}
                    value={String(weekDayId)}
                    onChange={(val) => setWeekDayId(parseInt(val))}>
              <Option value="1">شنبه</Option>
              <Option value="2">یکشنبه</Option>
              <Option value="3">دوشنبه</Option>
              <Option value="4">سه‌شنبه</Option>
              <Option value="5">چهارشنبه</Option>
              <Option value="6">پنجشنبه</Option>
              <Option value="7">جمعه</Option>
            </Select>

            <div className="flex flex-col md:flex-row w-full">
              <FromToTimeClock
                from_label="از ساعت:"
                to_label="تا ساعت:"
                from_value={startTime}
                to_value={endTime}
                onChangeFrom={setStartTime}
                onChangeTo={setEndTime}
              />
            </div>

            <div className="mb-4">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    فعال/غیرفعال
                  </Typography>
                }
                checked={status}
                onChange={(e) => {
                  setStatus(e.target.checked)
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        </Dialog>
      }
    </ValidatorProvider>
  );
}